var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "checkbox",
      class: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("label", { staticClass: "form-check-label no-user-select" }, [
        _c("input", {
          staticClass: "checkbox-input",
          attrs: { type: "checkbox", disabled: _vm.disabled },
          domProps: { checked: _vm.shouldBeChecked, value: _vm.value },
          on: { change: _vm.updateInput },
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "checkbox-box", class: { disabled: _vm.disabled } },
          [_c("i", { staticClass: "ion-checkmark" })]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "checkbox-text ellipsize" },
          [_vm._t("default")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/Checkbox/template.html?vue&type=template&id=734146b6&
// module id = 1034
// module chunks = 0